import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, FeatureState } from './page-selector.reducer';

const featureSelector = createFeatureSelector<FeatureState>(featureKey);

export const selectPages = createSelector(featureSelector, (s: FeatureState) => s.pages);

export const selectPagesFiltered = (term: string) =>
  createSelector(featureSelector, (s: FeatureState) => {
    if (!term || !term.length) {
      return s.pages;
    }
    return s.pages.filter((page) => {
      const title =
        page.pageVersions.find((pageVersion) => pageVersion.status === 'PUBLISHED')?.titleEnglish ||
        page.pageVersions.find((pageVersion) => pageVersion.status === 'DRAFT')?.titleEnglish ||
        '';
      const name =
        page.pageVersions.find((pageVersion) => pageVersion.status === 'PUBLISHED')?.internalName ||
        page.pageVersions.find((pageVersion) => pageVersion.status === 'DRAFT')?.internalName ||
        '';
      return title.toLowerCase().includes(term.toLowerCase()) || name.toLowerCase().includes(term.toLowerCase());
    });
  });

export const selectPageById = (id: string) => createSelector(featureSelector, (s: FeatureState) => s.pages?.find((page) => page.id === id));

export const selectIsLoading = createSelector(featureSelector, (s: FeatureState) => s.loading);
